// Path: ./src/app/components/CreateDealTopNav/index.tsx
import { PermissionComponentWrapper } from "../PermissionComponentWrapper";
import { TopNavWrapper, TopButtonNavigate } from "./styled";

interface Props {
  selected?: number | string;
  /**
   * Callback function to handle the click event for the CreateDealTopNav component.
   * This function is invoked when the CreateDealTopNav element is clicked, and it receives a numeric value as a parameter.
   * It redirect to different Tabs
   * @param value - The numeric value associated with the click event.
   */
  // eslint-disable-next-line
  onClick?: (value: number) => void;

  renderList: {
    label: string;
    requiredPermission: string[];
    requiredPermissionGroup: string[];
    dataTestId?: string;
  }[];
}
export const CreateDealTopNav = ({ selected, onClick, renderList }: Props) => {
  return (
    <TopNavWrapper data-testid="createdealtopnav-test-id">
      {renderList?.map((value, index) => {
        return (
          <PermissionComponentWrapper
            requiredPermission={value.requiredPermission}
            requiredPermissionGroup={value.requiredPermissionGroup}
            key={index}
            data-testid="createdealtopnav-test-id"
          >
            <TopButtonNavigate
              index={index}
              key={index}
              value={selected}
              onClick={() => {
                onClick && onClick(index);
              }}
              data-testid={value.dataTestId}
            >
              {value.label}
            </TopButtonNavigate>
          </PermissionComponentWrapper>
        );
      })}
    </TopNavWrapper>
  );
};
